import vueMain from '@/main'
import { store } from '@/store/store';
import { eventBus } from "@/eventBus";


export const makeQueryString = (dataObj) => {
    let queryStr = '?'
    dataObj.forEach((data) => {
        queryStr += `${data.key}=${data.value}&`
    })
    queryStr = queryStr.substring(0, queryStr.length - 1)
    return queryStr

}

export const makeQueryStringDync = (dataObj) => {
    if (!Object.keys(dataObj).length) return false;

    let queryStr = '?'
    for (let item in dataObj) {
        queryStr += `${item}=${dataObj[item]}&`
    }
    queryStr = queryStr.substring(0, queryStr.length - 1)
    return queryStr

}

export const makeQueryStringDynamic = (dataObj) => {
    if (!Object.keys(dataObj).length) return false;

    let queryStr = ''
    for (let item in dataObj) {
        queryStr += `${item}=${dataObj[item]},`
    }
    queryStr = queryStr.substring(0, queryStr.length - 1)
    return queryStr

}

export const errorServeiceHandler = (response) => {
    if ((response.status == 200 || response.status == 201) && response.ok) {
        return response
    } else {
        if (response.status == 401 && store.getters.getMode != "development") {
            localStorage.removeItem('lcoUser')
            localStorage.removeItem("subUser")
            eventBus.$emit("lco-loader", false);

            let messageObj = {};
            messageObj.status = true;
            messageObj.backgroundColor = false;
            messageObj.leftalign = 0;
            messageObj.minwidth = 100;
            messageObj.message = "No valid session exist"
            eventBus.$emit("lco-message", messageObj);

            return
            // setTimeout(() => {
            //     vueMain.$router.push({ name: "login" })
            // }, 4000);
        }
        throw response
    }

}

export const makeQueryFormDataDyn = (dataObj) => {
    if (!Object.keys(dataObj).length)
        return false;
    let obj = new FormData();
    for (let data in dataObj) {
        obj.append(data, dataObj[data])
    }
    // console.log("obj || helpers ",obj.getAll('mobileno'));
    return obj
}


// WEBPACK FOOTER //
// ./src/store/helper.js